import './App.css';
import { Inicio } from './inicio/inicio';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Inventario } from './inventario/inventario';
import { ActivoRegistro } from './activoregistro/activoregistro';
import { ActivoVer } from './activover/activover';

function App() {
  return (
    <Router>
      <header>
        <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
          <div className="container">

            {/*
              <img 
                src="./public/logo192.png" 
                height="40" 
                alt="Hagemsa Logo" 
                className="me-2" 
              />
              */}
              <span className="lg-2 text-danger fw-bold">Sistema de Inventario</span>
            
            
            
            
            
          </div>
        </nav>
      </header>

      <main className="container py-4">
        <Routes>
          <Route path="/activo" element={<Inicio/>} />
          <Route path="/activo/inventario" element={<Inventario/>} />
          <Route path="/activo/registro" element={<ActivoRegistro/>} />
          <Route path="/activo/ver" element={<ActivoVer/>} />
        </Routes>
      </main>

      <footer className="text-center text-white">
        <div className="container p-0">
          <div className="row align-items-center">
            <div className="col-12">
              <a href="http://www.hagemsa.com" className="text-white text-decoration-none">
                HAGEMSA
              </a> © 2008-{new Date().getFullYear()} Todos los derechos reservados.
              <br/>
              <small className="text-muted">Versión 1.1</small>
            </div>
          </div>
        </div>
      </footer>
    </Router>
  );
}

export default App;
